import { useAuth } from "@/contexts/AuthContext";

export const MODULE_MAP = {
  "nav-finance": "financeiro", "nav-outsourced": "financeiro", "nav-calculators": "financeiro",
  "nav-invoices": "fiscal",
  "nav-stock": "estoque", "nav-purchases": "estoque", "nav-suppliers": "estoque", "nav-counter-sale": "estoque",
  "nav-reminders": "crm", "nav-funnel": "crm", "nav-post-sale": "crm", "nav-satisfaction": "crm", "nav-loyalty": "crm",
  "nav-employees": "rh",
  "nav-yard": "patio",
  "nav-bookings": "agendamento",
  "nav-kpi": "relatorios", "nav-profit": "relatorios", "nav-team": "relatorios",
};

export const ROUTE_MODULE = [
  [/^\/owner\/financeiro/, "financeiro"], [/^\/owner\/terceirizados/, "financeiro"], [/^\/owner\/calculadoras/, "financeiro"], [/^\/owner\/conciliar/, "financeiro"],
  [/^\/owner\/notas/, "fiscal"],
  [/^\/owner\/estoque/, "estoque"], [/^\/owner\/compras/, "estoque"], [/^\/owner\/fornecedores/, "estoque"], [/^\/owner\/balcao/, "estoque"],
  [/^\/owner\/lembretes/, "crm"], [/^\/owner\/funil/, "crm"], [/^\/owner\/pos-venda/, "crm"], [/^\/owner\/satisfacao/, "crm"], [/^\/owner\/clube/, "crm"],
  [/^\/owner\/funcionarios/, "rh"],
  [/^\/owner\/patio/, "patio"],
  [/^\/owner\/agendamentos/, "agendamento"],
  [/^\/owner\/dashboard/, "relatorios"], [/^\/owner\/rentabilidade/, "relatorios"], [/^\/owner\/equipe/, "relatorios"],
];

export function useModules() {
  const { user } = useAuth();
  const m = user?.shop?.modules || {};
  const enabled = (key) => m[key] !== false;
  return { modules: m, enabled };
}

export function moduleForRoute(path) {
  for (const [re, mod] of ROUTE_MODULE) if (re.test(path)) return mod;
  return null;
}
